import { useEffect } from "react";
import { UrgewaldsCard } from "./card";
import { UrgewaldsNew } from "./new";
import { Routes, Route } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { UrgewaldsTable } from "./table";

export default function Urgewald() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Urgewalds");
  }, []);

  return (
    <Routes>
      <Route index element={<UrgewaldsTable />} />
      <Route path="/new" element={<UrgewaldsNew />} />
      <Route path=":id" element={<UrgewaldsCard />} />
    </Routes>
  );
}
